module.exports = __webpack_public_path__ + "img/logo.42ad3885.png";